import { ClipboardModule } from '@angular/cdk/clipboard';
import { AsyncPipe } from '@angular/common';
import { DatePipe, NgStyle, TitleCasePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FwFormHeadingModule, FwIconModule, FwProgressModule, FwSelectMenuModule, FwTooltipModule } from '@flywheel-io/vision';

import { OperationCancelPopoverBodyComponent } from './components/operation-cancel-popover-body/operation-cancel-popover-body.component';
import { OperationFeedbackItem } from './components/operation-feedback/operation-feedback-item/operation-feedback-item.component';
import { OperationFeedback } from './components/operation-feedback/operation-feedback.component';
import { OperationInfoComponent } from './components/operation-info/operation-info.component';
import { OperationPopoverComponent } from './components/operation-popover/operation-popover.component';
import { OperationStatusComponent } from './components/operation-status/operation-status.component';
import { OperationStorageSelect } from './components/operation-storage-select/operation-storage-select.component';
import { OperationTableWithProgress } from './components/operation-table-with-progress/operation-table-with-progress.component';
import { OperationTable } from './components/operation-table/operation-table.component';
import { OperationsBlankStateComponent } from './components/operations-blank-state/operations-blank-state.component';
import { OperationsDetailsTable } from './components/operations-details-table/operations-details-table.component';
import { StatusChipComponent } from './components/status-chip/status-chip.component';
import { PipesModule } from '../shared/pipes.module';
import { SharedModule } from '../shared/shared.module';

@NgModule({
  imports: [AsyncPipe, DatePipe, ClipboardModule, FwFormHeadingModule, FwIconModule, FwProgressModule, FwSelectMenuModule, FwTooltipModule, NgStyle, PipesModule, SharedModule, TitleCasePipe],
  declarations: [
    OperationCancelPopoverBodyComponent,
    OperationFeedback,
    OperationFeedbackItem,
    OperationInfoComponent,
    OperationPopoverComponent,
    OperationStatusComponent,
    OperationStorageSelect,
    OperationTable,
    OperationTableWithProgress,
    OperationsBlankStateComponent,
    OperationsDetailsTable,
    StatusChipComponent,
  ],
  exports: [
    OperationCancelPopoverBodyComponent,
    OperationFeedback,
    OperationFeedbackItem,
    OperationInfoComponent,
    OperationPopoverComponent,
    OperationStatusComponent,
    OperationStorageSelect,
    OperationTable,
    OperationTableWithProgress,
    OperationsBlankStateComponent,
    OperationsDetailsTable,
    StatusChipComponent,
  ],
})
export class XferModule { }
